import { FilterData } from '@/api/generatedApi';
import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';
import { useDataGridFetcher } from '@/hooks/api/useDataGridFetcher';
import { useSearchFilters } from '@/hooks/useSearchFilters';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

export const LIST_ASSETS_WITHOUT_LABELS_QUERY_KEY = 'assets.listAssetsWithoutLabels';

export const useFetchAssetsWithoutLabels = () => {
  const { getTenantId } = useTenants();
  const { selectedFilters } = useSearchFilters();

  const foldersParameter = selectedFilters.folders.length > 0 ? selectedFilters.folders.join(',') : undefined;
  const extensionsParameter = selectedFilters.extensions.length > 0 ? selectedFilters.extensions.join(',') : undefined;

  return useDataGridFetcher({
    queryKey: parameters => [
      LIST_ASSETS_WITHOUT_LABELS_QUERY_KEY,
      {
        tenantId: getTenantId(),
        page: +(parameters?.page ?? 1),
        perPage: +(parameters?.perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
        folders: foldersParameter,
        extensions: extensionsParameter,
      },
    ],
    queryFn: parameters => () =>
      api.assets.listAssetsWithoutLabels({
        tenantId: getTenantId(),
        page: +(parameters?.page ?? 1),
        perPage: +(parameters?.perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
        folders: foldersParameter,
        extensions: extensionsParameter,
      }),
    transformResponse: data => ({
      matches: data.assets.map(asset => ({ asset, matchPercentage: undefined })),
      pageData: data.pageData,
      filterData: data.filterData as Partial<FilterData> | undefined,
    }),
  });
};
